export interface ChatMessage {
  id: string;
  sender: 'user' | 'bot';
  text: string;
  timestamp: Date;
}

/**
 * Simulates sending a message to the AI API and receiving a response.
 * Replace the implementation with actual API calls to your backend later.
 */
export async function sendMessageToAI(message: string): Promise<string> {
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 1500));

  const lowerMessage = message.toLowerCase();
  
  if (lowerMessage.includes('hello') || lowerMessage.includes('hi')) {
    return "Hello! How can I assist you with your Workflow activities today?";
  }
  if (lowerMessage.includes('help')) {
    return "I can help you build workflows, explain templates, and navigate the portal. What do you need help with?";
  }
  if (lowerMessage.includes('workflow')) {
    return "Workflow AI helps you streamline your processes. Would you like to view your workflow templates?";
  }

  return "I'm a simple assistant for now. Please ask me about workflows or how I can help you.";
}
